import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {Http, Headers, RequestOptions} from '@angular/http';
// import {Http, Headers, Request, RequestOptions, RequestOptionsArgs, RequestMethod, Response} from '@angular/http';

import {JwtHelper} from 'angular2-jwt';
// import {AuthHttp, tokenNotExpired, JwtHelper} from 'angular2-jwt';

// import {Observable} from 'rxjs/Observable';

import * as uuid from 'uuid';

import {ConfigService} from './config.service';
import {LogService} from './log.service';
import {VersionService} from './version.service';

import * as url from 'url';

declare var window: any;


// TODO - add "edit" to each
let fullAuth = {
	passes: {
		passContent: true,
		passesSettings: true
	},
	realtimeSeats: {
		theaterManager: 'rose-theater',
		realtimeSeatsSettings: true
	},
	reviewer: {
		reviewer: 'documentary',
		teamCapitan: 'documentary',
		festivalProgrammer: 'all',
		filmContent: true,
		reviewerSettings: true
	}
};


@Injectable()
export class AuthService {
	constructor(
		private http: Http,
		private location: Location,
		private router: Router,

		private config: ConfigService,
		private log: LogService,
		private versionService: VersionService
	) {
		// try and read userId etc.
		try {
			if (localStorage) {
				let authJwt = localStorage.getItem('auth-jwt');
				if (!authJwt) {
					return;
				}

				let authPayload = this.jwtHelper.decodeToken(authJwt);
				if (!authPayload) {
					return;
				}
				this.userId = authPayload.auth.userId;
				this.organizationId = authPayload.auth.organizationId;
				this.eventId = authPayload.auth.eventId;
				this.userAuthorizations = authPayload.auth.userAuthorizations;
			} else {
				log.error('localStorage');
			}
		} catch (ex) {
			log.exception(ex);
		}
	}


	jwtHelper: JwtHelper = new JwtHelper();

	lastModified = {
		allUsers: 0,
		allFilms: 0,
		allReviews: 0,
		userUsers: 0,
		userFilms: 0,
		userReviews: 0,
	};

	userId = '';
	organizationId = '';
	eventId = '';

	userAuthorizations: any = {};
	showRoleReviewerTeam: any = '';
	showRoleTeamCaptainTeam: any = '';


	// first check if path is in no-auth list, if yes simply return
	// if no local jwt, or jwt expired, redirect to "/"
	// try API, get new jwt + last modified dates
	// save jwt + last modified dates
	// if no internet, use last saved
	// if no jwt, redirct to "/"
	// if jwt expired, redirect to "/"
	// verify jwt allows path
	// if not, redirect to "/"
	ensureAuth(path: string) {
		return new Promise( (resolve, reject) => {
			if (this.log.needPageReLoad) {
				this.log.needPageReLoad = false;
				window.location.reload(true);
				return resolve();
			}

			// console.log('ensureAuth, path');
			// console.log(path);

			// check no-auth list
			if (['', '/'].indexOf(path) >= 0) {
				return resolve();
			}

			if (path.indexOf('/nonce/') === 0) {
				return resolve();
			}

			if (path.indexOf('/site/') === 0) {
				return resolve();
			}

			if (path.indexOf('/oauth') === 0) {
				return resolve();
			}

// TODO - fix this !!!
			if (path.indexOf('/volunteer/') === 0) {
				return resolve();
			}

// TODO - fix this !!!
			// if (path.indexOf('/festival/') === 0) {
			// 	return resolve();
			// }
			if (path.indexOf('/festival/5dde71766d5342f39e8a0abfaaeab3f4/nextup') === 0) {
				return resolve();
			}

			if (path === '/festival/nextup') {
				this.router.navigate(['/festival/5dde71766d5342f39e8a0abfaaeab3f4/nextup']);
				return resolve();
			}

			if (path === '/festival/tickets') {
				this.router.navigate(['/festival/5dde71766d5342f39e8a0abfaaeab3f4/tickets']);
				return resolve();
			}



			let authPayload: any = this.readAuthFromLocalStorage();
			if (!authPayload) {
				this.router.navigate(['']);
				return resolve();
			}

/*
			if (!window.localStorage) {
				this.log.warn('ensureAuth, Browser does not support local storage.');
				this.router.navigate(['']);
				return resolve();
			}

			let authJwt = localStorage.getItem('auth-jwt');
			if (!authJwt) {
				this.log.warn('ensureAuth, auth-jwt missing from local storage.');
				this.router.navigate(['']);
				return resolve();
			}

			let expireDate = this.jwtHelper.getTokenExpirationDate(authJwt);
			// console.log('local jwt expires = ' + expireDate);
			if (!expireDate) {
				this.log.warn('ensureAuth, auth-jwt from local storage missing expireDate.');
				this.router.navigate(['']);
				return resolve();
			}

			if (new Date() > expireDate) {
				this.log.warn('ensureAuth, auth-jwt from local storage has expired.  expireDate = ' + expireDate);
				this.router.navigate(['']);
				return resolve();
			}

			let authPayload = this.jwtHelper.decodeToken(authJwt);
			if (!authPayload) {
				this.log.warn('ensureAuth, No authPayload while decoding auth-jwt.');
				this.router.navigate(['']);
				return resolve();
			}
			this.userId = authPayload.auth.userId;
			this.organizationId = authPayload.auth.organizationId;
			this.eventId = authPayload.auth.eventId;
			this.userAuthorizations = authPayload.auth.userAuthorizations;
			this.showRoleReviewerTeam = authPayload.auth.showRoleReviewerTeam;
			this.showRoleTeamCaptainTeam = authPayload.auth.showRoleTeamCaptainTeam;
			// console.log(authPayload);
*/

			this.getNewJwtAndModifiedDates(authPayload)
				.then((res: any) => {
					let result: any = res.result;

					if (this.versionService.isNewVersion(result.uiVersion)) {
						let currentVersion = this.versionService.uiVersion.version;
						this.log.info('Found new UI version.  current v' + currentVersion + ', new v' + result.uiVersion);
						window.location.reload(true);
						return resolve();
					}

					// let newExpireDate = this.jwtHelper.getTokenExpirationDate(result.token);
					// console.log('new jwt expires = ' + newExpireDate);

					let newAuthPayload = this.jwtHelper.decodeToken(result.token);
					if (!newAuthPayload) {
						this.log.warn('ensureAuth, No newAuthPayload while decoding newAuth.');
						this.router.navigate(['']);
						return resolve();
					}
					localStorage.setItem('auth-jwt', result.token);
					this.userId = newAuthPayload.auth.userId;
					this.organizationId = newAuthPayload.auth.organizationId;
					this.eventId = newAuthPayload.auth.eventId;
					this.userAuthorizations = newAuthPayload.auth.userAuthorizations;
					this.showRoleReviewerTeam = authPayload.auth.showRoleReviewerTeam;
					this.showRoleTeamCaptainTeam = authPayload.auth.showRoleTeamCaptainTeam;
					// console.log('newAuthPayload');
					// console.log(newAuthPayload);

					let parts = path.split('/');
					if (parts.length > 0) {
						parts = parts.slice(1);
						let pathname = 'app.' + parts.join('.');

						// console.log('pathname before');
						// console.log(pathname);


						// TODO!!! - fix this !!!
						if (pathname.indexOf('app.festival.5dde71766d5342f39e8a0abfaaeab3f4.tickets') === 0) {
							pathname = 'app.festival.ticket';
						}


						if (pathname.indexOf('app.organization.settings') === 0) {
							pathname = 'app.organization.settings';
						}

						if (pathname.indexOf('app.program.lineup') === 0) {
							pathname = 'app.program.lineup';
						}
						if (pathname.indexOf('app.program.letter') === 0) {
							pathname = 'app.program.letter';
						}
						if (pathname.indexOf('app.program.block') === 0) {
							pathname = 'app.program.block';
						}
						if (pathname.indexOf('app.program.grid') === 0) {
							pathname = 'app.program.grid';
						}
						if (pathname.indexOf('app.program.ballot') === 0) {
							pathname = 'app.program.ballot';
						}


						if (pathname.indexOf('app.reviewer.program') === 0) {
							pathname = 'app.reviewer.program';
						}


						if (pathname.indexOf('app.reviewer.results') === 0) {
							pathname = 'app.reviewer.results';
						}
						if (pathname.indexOf('app.reviewer.team') === 0) {
							pathname = 'app.reviewer.team';
						}
						if (pathname.indexOf('app.reviewer.content') === 0) {
							pathname = 'app.reviewer.content';
						}
						if (pathname.indexOf('app.reviewer.available') === 0) {
							pathname = 'app.reviewer.available';
						}
						if (pathname.indexOf('app.reviewer.reviewing') === 0) {
							pathname = 'app.reviewer.reviewing';
						}
						if (pathname.indexOf('app.reviewer.reviewed') === 0) {
							pathname = 'app.reviewer.reviewed';
						}
						if (pathname.indexOf('app.reviewer.all') === 0) {
							pathname = 'app.reviewer.all';
						}

						if (pathname.indexOf('app.common.contacts') === 0) {
							pathname = 'app.common.contacts';
						}
						if (pathname.indexOf('app.common.profile') === 0) {
							pathname = 'app.common.profile';
						}


						if (pathname.indexOf('app.dashboard.contact') === 0) {
							pathname = 'app.dashboard.contact';
						}
						if (pathname.indexOf('app.dashboard.film') === 0) {
							pathname = 'app.dashboard.film';
						}


						if (pathname.indexOf('app.system.email') === 0) {
							pathname = 'app.system.email';
						}
						// if (pathname.indexOf('app.profile') === 0) {
						// 	pathname = 'app.profile';
						// }

						// console.log('pathname after');
						// console.log(pathname);

						if (newAuthPayload.auth.userAuthorizations[pathname]) {
							// console.log('url ' + path + ' is authorized by ' +  pathname);
							return resolve(newAuthPayload.auth);
						} else {
							this.log.warn('url ' + path + ' is not authorized by ' +  pathname);
							this.router.navigate(['']);
							return resolve();
						}
					}
					return resolve();
				})
				.catch((err: any) => {
					// don't redirect or will be in endless loop
					this.log.error(err);
					return resolve();
				});
		});
	}


	readAuthFromLocalStorage() {
		let authJwt = localStorage.getItem('auth-jwt');
		if (!authJwt) {
			this.log.warn('ensureAuth, auth-jwt missing from local storage.');
			return null;
		}

		let expireDate = this.jwtHelper.getTokenExpirationDate(authJwt);
		// console.log('local jwt expires = ' + expireDate);
		if (!expireDate) {
			this.log.warn('ensureAuth, auth-jwt from local storage missing expireDate.');
			return null;
		}

		if (new Date() > expireDate) {
			this.log.warn('ensureAuth, auth-jwt from local storage has expired.  expireDate = ' + expireDate);
			return null;
		}

		let authPayload = this.jwtHelper.decodeToken(authJwt);
		if (!authPayload) {
			this.log.warn('ensureAuth, No authPayload while decoding auth-jwt.');
			return null;
		}
		this.userId = authPayload.auth.userId;
		this.organizationId = authPayload.auth.organizationId;
		this.eventId = authPayload.auth.eventId;
		this.userAuthorizations = authPayload.auth.userAuthorizations;
		this.showRoleReviewerTeam = authPayload.auth.showRoleReviewerTeam;
		this.showRoleTeamCaptainTeam = authPayload.auth.showRoleTeamCaptainTeam;
		return authPayload;
	}


	private getNewJwtAndModifiedDates(authPayload: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });
			this.http.get(this.config.basePath + '/v0/tokens/newjwtmodifydatesuiversion', options)
				.toPromise()
				.then((res) => {
					return resolve(res.json());
				})
				.catch((err: any) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					return reject(err);
				});
		});
	}


	switchOrganizationAndEvent(organizationId: string, eventId: string, observer: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({
				'Authorization': 'Bearer ' + accessToken,
				'Content-Type': 'application/json'
			});
			let options = new RequestOptions({ headers: headers });

			let payload = {
				organizationId: organizationId,
				eventId: eventId,
				observer: observer
			};
			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/tokens/switch', body, options)
				.toPromise()
				.then((res) => {
					let foo = res.json();
					// console.log(foo);
					return resolve(foo);
				})
				.catch((err: any) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					return reject(err);
				});
		});
	}


	redirectIfAuthorized() {
		if (!window.localStorage) {
			this.log.warn('redirectIfAuthorized, Browser does not support local storage.');
			return false;
		}

		let authJwt = localStorage.getItem('auth-jwt');
		if (!authJwt) {
			this.log.warn('redirectIfAuthorized, auth-jwt missing from local storage.');
			return false;
		}

		let expireDate = this.jwtHelper.getTokenExpirationDate(authJwt);
		// console.log('local jwt expires = ' + expireDate);
		if (new Date() > expireDate) {
			this.log.warn('redirectIfAuthorized, auth-jwt from local storage has expired.  expireDate = ' + expireDate);
			return false;
		}

		let authPayload = this.jwtHelper.decodeToken(authJwt);
		if (!authPayload) {
			this.log.warn('redirectIfAuthorized, No authPayload while decoding auth-jwt.');
			return false;
		}
		console.log('authPayload');
		console.log(authPayload);



		// TODO!!! - add more sophisticated redirect logic here !!!
		let originalHref = this.log.originalHref;
		console.log('redirectIfAuthorized, originalHref');
		console.log(originalHref);

		let theUrl: any;
		try {
			theUrl = url.parse(originalHref);
			console.log('theUrl');
			console.log(theUrl);

			let parts = theUrl.pathname.split('/');
			console.log('redirectIfAuthorized, pathname parts');
			console.log(parts);

			if (parts.length > 1) {
				let pathBase = parts[1].toLowerCase();
				if (pathBase === 'oauth') {
					console.log('found pathBase oauth');
					return false;
				}
			}
		} catch (err) {
			this.log.error('Error parsing href, originalHref = ' + originalHref);
			this.log.error(err);
		}



		// TODO!!! - remove, temp hack
		if (
			// (authPayload.auth.userId === 'c3bed8716ae14d6693b336dfce19d02e') ||		// Pat McFaul
			(authPayload.auth.userId === '647418a39d724bef86b1b244b6c40a8a') ||		// BFF, Selin Sevinc
			(authPayload.auth.userId === 'd1530b1b2b6b4ed6b65f3671e632b683') ||		// BFF, Ted Speaker
			(authPayload.auth.userId === '71e297b3621840b8ba30f57b42557d9b')		// BFF, Paul Sturtz
		) {
			this.router.navigate(['/reviewer/all']);
			return true;
		}




		// first check if authorized for festival.ticket
		if (authPayload.auth.userAuthorizations['app.festival.ticket']) {
			this.router.navigate(['/festival/5dde71766d5342f39e8a0abfaaeab3f4/nextup']);
			return true;
		}

		// first check if authorized for reviewer.available
		if (authPayload.auth.userAuthorizations['app.reviewer.available']) {
			this.router.navigate(['/reviewer/available']);
			return true;
		}

		// second check if authorized for common.profile
		if (authPayload.auth.userAuthorizations['app.common.profile']) {
			this.router.navigate(['/common/profile']);
			return true;
		}

		// else nope
		return false;
	}


	getAuth() {
		return new Promise( (resolve, reject) => {
			return resolve(fullAuth);
			// this.http.get('http://localhost:3000/v0/version')
			// 	.subscribe( (res) => {
			// 		console.log(res.json());
			// 		resolve(  JSON.stringify(res.json(), null, 4)    );
			// 	});
		});
	}


	getSavedAuth() {
		let authJwt = localStorage.getItem('auth-jwt');
		if (!authJwt) {
			return [];
		}

		let expireDate = this.jwtHelper.getTokenExpirationDate(authJwt);
		if (!expireDate) {
			return [];
		}

		if (new Date() > expireDate) {
			return [];
		}

		let authPayload = this.jwtHelper.decodeToken(authJwt);
		if (!authPayload) {
			return [];
		}

		// console.log('authPayload.auth.userAuthorizations');
		// console.log(authPayload.auth.userAuthorizations);

		return authPayload.auth.userAuthorizations;
	}


	clearCache() {
		if (window.localStorage) {
			localStorage.removeItem('all-films');
			localStorage.removeItem('all-reviews');
			localStorage.removeItem('all-users');

			localStorage.removeItem('user-films');
			localStorage.removeItem('user-profile');
			localStorage.removeItem('user-reviews');

			localStorage.removeItem('all-filter');
			localStorage.removeItem('reviewed-filter');
			localStorage.removeItem('available-filter');

			localStorage.removeItem('visible-tabs');

			localStorage.removeItem('enable-ballot-report');
		}
	}


	authUsingNonce(userId: string, nonce: string) {
		return new Promise( (resolve, reject) => {

			// let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Content-Type': 'application/json'});
			let options = new RequestOptions({ headers: headers });

			let randomPassword = uuid.v4().replace(/-/g, '');

			// let passwordResetExpires = Date.now() + 30 days; ??
			let passwordResetExpires = Date.now(); // currently not checked

			let payload = {
				password: randomPassword,
				passwordResetToken: nonce,
				passwordResetExpires: passwordResetExpires,
				noPassword: true
			};
			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/users/' + userId + '/nopassword', body, options)
				.toPromise()
				.then( (res) => {
					let foo = res.json();

					// console.log(foo);
					let bar: any = foo;

					console.log('authUsingNonce, saving auth-jwt');
					localStorage.setItem('auth-jwt', bar.token);

					let authPayload = this.jwtHelper.decodeToken(bar.token);
					if (authPayload && authPayload.auth) {
						console.log('authUsingNonce, successfully decoded auth-jwt');
						this.userId = authPayload.auth.userId;
						this.organizationId = authPayload.auth.organizationId;
						this.eventId = authPayload.auth.eventId;
						console.log('authUsingNonce, setting userId, organizationId, and eventId.  userId=' + this.userId + ', organizationId=' + this.organizationId + ', eventId=' + this.eventId);
					}

					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					reject();
				});
		});
	}


	authUsingActivationCode(activationCode: string) {
		return new Promise( (resolve, reject) => {
			let headers = new Headers({'Content-Type': 'application/json'});
			let options = new RequestOptions({ headers: headers });

			let payload = {
				activationCode: activationCode
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/users/activation', body, options)
				.toPromise()
				.then((res) => {
					let result = res.json();

					// // console.log(foo);
					// let bar: any = foo;

					if (result.messageId === 'token-created') {
						console.log('authUsingActivationCode, saving auth-jwt');
						localStorage.setItem('auth-jwt', result.token);

						let authPayload = this.jwtHelper.decodeToken(result.token);
						if (authPayload && authPayload.auth) {
							console.log('authUsingActivationCode, successfully decoded auth-jwt');
							this.userId = authPayload.auth.userId;
							this.organizationId = authPayload.auth.organizationId;
							this.eventId = authPayload.auth.eventId;
							console.log('authUsingActivationCode, setting userId, organizationId, and eventId.  userId=' + this.userId + ', organizationId=' + this.organizationId + ', eventId=' + this.eventId);
						}
					}

					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					reject(err);
				});
		});
	}

}




// TODO - detetct "private mode browsing on iOS !!!


	// "_id" : ObjectId("57a6434a98cbc7906c93070b"),
	// "deletedBy" : "",
	// "deleted" : null,
	// "modifiedBy" : "",
	// "modified" : 1470513994714,
	// "createdBy" : "",
	// "created" : 1470513994714,
	// "browserDownloadSpeed" : "",
	// "browserPerformance" : "{}",
	// "browserScreenSize" : "{\"screen\":{\"width\":768,\"height\":1024},\"window\":{\"width\":1024,\"height\":649},\"document\":{\"width\":1024,\"height\":649}}",
	// "browserUserAgent" : "{\"ua\":\"Mozilla/5.0 (iPad; CPU OS 9_3_3 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Version/9.0 Mobile/13G34 Safari/601.1\",\"browser\":{\"name\":\"Mobile Safari\",\"version\":\"9.0\",\"major\":\"9\"},\"engine\":{\"version\":\"601.1.46\",\"name\":\"WebKit\"},\"os\":{\"name\":\"iOS\",\"version\":\"9.3.3\"},\"device\":{\"model\":\"iPad\",\"vendor\":\"Apple\",\"type\":\"tablet\"},\"cpu\":{}}",
	// "browserIpAddress" : "47.215.230.64",
	// "browserHeaders" : "{\"x-forwarded-for\":\"47.215.230.64\",\"host\":\"api.ptffportal.org\",\"x-real-ip\":\"47.215.230.64\",\"x-forwarded-proto\":\"https\",\"connection\":\"close\",\"content-length\":\"1679\",\"accept\":\"*/*\",\"accept-language\":\"en-us\",\"accept-encoding\":\"gzip, deflate\",\"content-type\":\"application/json\",\"origin\":\"https://oceanbluffproductions.com\",\"referer\":\"https://oceanbluffproductions.com/\",\"dnt\":\"1\"}",
	// "stackTrace" : "setItem@[native code]\n\ninvoke@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:7220\nonInvoke\ninvoke@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:7174\nrun@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:4608\nhttps://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:3339\ninvokeTask@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:7851\nonInvokeTask\ninvokeTask@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:7794\nrunTask@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:5214\na@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:2435\ninvoke@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:8990",
	// "codeLocation" : "invoke@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:7220",
	// "message" : "Error: QuotaExceededError: DOM Exception 22",
	// "errorSource" : "",
	// "type" : "error",
	// "logSource" : "ui",
	// "logId" : "3749ef30bd244bd1810d4c13cc0d16de",
	// "__v" : 0







// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/auth.service.ts